import { render, staticRenderFns } from "./ScaleTabs.vue?vue&type=template&id=920a8328&scoped=true&"
import script from "./ScaleTabs.vue?vue&type=script&lang=js&"
export * from "./ScaleTabs.vue?vue&type=script&lang=js&"
import style0 from "./ScaleTabs.vue?vue&type=style&index=0&id=920a8328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920a8328",
  null
  
)

export default component.exports